export function createHandlePresenceUpdated({ agentName, setPresence }) {
  return ({ bot_number: botNumber, phone_number: phoneNumber, users = [] }) => {
    if (!botNumber || !phoneNumber) return;
    const key = `${botNumber}:${phoneNumber}`;
    const viewers = users.filter((name) => name && name !== agentName);
    setPresence((prev) => ({ ...prev, [key]: viewers }));
  };
}
